export default "__VITE_ASSET__Dcfd5NIq__"